@if (assetNotFound) {
  <div class="row">
    <div class="col-12 mb-2 text-color-error">{{ 'trade.create.asset.not-found' | transloco }}</div>
  </div>
}
@if (asset) {
  <div class="row">
    <div class="col-12">
      <div class="input-group-material asset-search-default">
        <input class="cursor-pointer" [value]="asset.name" (click)="resetAsset.emit()" />
        <button class="autocompletion-clear close" type="button" (click)="resetAsset.emit()">
          <svg class="icon icon-16 color-secondary">
            <use xlink:href="/assets/img/svgs/svgset.svg#edit" />
          </svg>
        </button>
      </div>
    </div>
  </div>

  <div class="row text-size-small remove-extrange-margin">
    @if (asset.instrumentType !== InstrumentType.Crypto) {
      <div class="col-12 col-sm-4" data-zid="instrument-isin">ISIN: {{ asset.isin }}</div>
      @if (asset.fractionalTrading) {
        <div class="col-12 col-sm-8 zero-text text-left text-md-right">
          <span class="pr-1" [innerHTML]="'trade.create.quote.fractional' | transloco"></span>
          <web-design-system-icon name="fractional-trading" size="small" />
        </div>
      }
    } @else {
      <div class="col-12" data-zid="instrument-isin">Kürzel: {{ asset.shortName }}</div>
    }
  </div>
} @else {
  <web-components-asset-search
    [isDisabled]="isDisabled"
    (assetSelected)="selectAsset.emit($event)"
    class="asset-search"
    data-zid="asset-search"
  />
}

<div class="mb-2"></div>
